import { FC } from "react";
import { IconProps } from "@chakra-ui/react";
import { PRODUCT_MAPPING } from "../constants";

interface ProductLogoProps extends IconProps {
  slug: string;
}

export const ProductLogo: FC<ProductLogoProps> = ({ slug, ...iconProps }) => {
  const product = PRODUCT_MAPPING[slug];

  if (!product) {
    return null;
  }

  const Logo = product.logo;
  return <Logo {...iconProps} />;
};
